import { ParolaChiave } from '@hm_app/@core/models/info';
import { Component, OnInit } from '@angular/core';
import { Faq } from '@hm_app/@core/models/info';
import { MultiLangString } from '@hm_app/@core/models/lingua_sistema';

@Component({
    selector: 'ngx-faq-per-parola-chiave',
    templateUrl: './faq-per-parola-chiave.component.html',
    styleUrls: ['./faq-per-parola-chiave.component.scss'],
})
export class FaqPerParolaChiaveComponent implements OnInit {

    faqs: Faq[];
    parole_chiave: ParolaChiave[];
    keyword: MultiLangString;

    constructor() { }

    ngOnInit() {
    }

}
